import React, { useContext, useState } from "react";

import { InputSwitch } from "primereact/inputswitch";

import { ToastContext } from "../../../../App";
import {
  useGetStationManagersQuery,
  useUpdateStationManagerNotificationMutation,
} from "../../../../redux/services/foodStation";
import getSubdomain from "../../../../utils/getSubdomain";

import * as stationStyles from "../Stations.module.css";
import * as styles from "./StationManagersNotification.module.css";

function StationManagersNotification({ stationId }) {
  const showToast = useContext(ToastContext);
  const subdomain = getSubdomain();
  const [pendingId, setPendingId] = useState(null);

  const {
    data: managers,
    isLoading,
    isError,
  } = useGetStationManagersQuery(
    { id: stationId, subdomain },
    { skip: !stationId },
  );

  const [updateManagerNotification] =
    useUpdateStationManagerNotificationMutation();

  const onToggle = async (manager, value) => {
    setPendingId(manager.id);
    try {
      await updateManagerNotification({
        id: stationId,
        userId: manager.id,
        subdomain,
        sms_enabled: value,
      }).unwrap();

      showToast(
        "success",
        "Managers",
        `SMS notifications ${value ? "enabled" : "disabled"} for ${manager.name}`,
      );
    } catch (error) {
      showToast(
        "error",
        error?.status || "Managers",
        error?.data?.message ||
          (error?.data?.errors && "Incorrect data") ||
          "Failed to update notification",
      );
    } finally {
      setPendingId(null);
    }
  };

  return (
    <div className="field">
      <label>Notify Managers about new orders</label>
      <p className={styles.hint}>
        Managers with SMS notifications enabled will receive a text message when
        this station gets a new order.
      </p>

      {isLoading ? (
        <div className={styles.empty}>
          <i className="pi pi-spin pi-spinner" style={{ fontSize: 24 }}></i>
        </div>
      ) : isError ? (
        <div className={styles.empty}>Failed to load managers.</div>
      ) : !managers || managers.length === 0 ? (
        <div className={styles.empty}>No managers found.</div>
      ) : (
        <div className={stationStyles.cardList}>
          {managers.map((manager) => {
            const enabled =
              manager.sms_enabled === 1 || manager.sms_enabled === true;
            return (
              <div key={manager.id} className={stationStyles.cardItem}>
                <div className={styles.managerInfo}>
                  <span className={styles.managerName}>{manager.name}</span>
                  {manager.email && (
                    <span className={styles.managerSub}>{manager.email}</span>
                  )}
                  {manager.phone && (
                    <span className={styles.managerSub}>{manager.phone}</span>
                  )}
                </div>
                <InputSwitch
                  checked={enabled}
                  disabled={pendingId === manager.id}
                  onChange={(e) => onToggle(manager, e.value)}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default StationManagersNotification;
